import { getLogoPath, isThemeBackgroundAsset } from "common/assetUtils";
import { ds } from "js/core/models/dataService";
import Logos from "js/core/models/logos";

export async function getThemeBackgroundImageUrl(backgroundImage, { size = "original", reloadCache = false } = {}) {
    if (!backgroundImage?.asset) {
        return null;
    }

    if (isThemeBackgroundAsset(backgroundImage)) {
        const asset = await ds.assets.getAssetById(backgroundImage.asset, backgroundImage.content_type);
        return asset.getURL(size, reloadCache);
    }

    return Logos.getSignedUrlAndLoad(getLogoPath(backgroundImage.asset), reloadCache);
}
